module.exports = __webpack_public_path__ + "static/media/hr-1541476768539-2048x2048.823ae544.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/community-gardens/hr-1541476768539-2048x2048.png
// module id = 835
// module chunks = 12